// extracted by mini-css-extract-plugin
export default {"NavBar":"NavBar_NavBar__3g0Tm","NavBar__close":"NavBar_NavBar__close__23aDT","NavBar__close_tablet":"NavBar_NavBar__close_tablet__NtPkX"};